module.exports = __webpack_public_path__ + "img/btn-left.d083fd89.png";